import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnDestroy, OnInit, inject } from '@angular/core';
import { FormControl, FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FuseConfigService } from '@fuse/services/config.service';
import { FuseConfig } from '@fuse/types';
import { LocalStorageService } from 'app/core/services/local-storage.service';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { ThemeSelector } from '../../../../../@fuse/types/theme-selector';
import { ThemeSelectorFormGroup } from './theme-selector-form-group';
import { MatRadioGroup, MatRadioButton } from '@angular/material/radio';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  changeDetection: ChangeDetectionStrategy.Eager,
  selector: 'app-theme-selector',
  styleUrls: ['./theme-selector.component.scss'],
  templateUrl: './theme-selector.component.html',
  imports: [FormsModule, ReactiveFormsModule, MatRadioGroup, MatRadioButton, TranslatePipe],
})
export class ThemeSelectorComponent implements OnInit, OnDestroy {
  public formGroup: FormGroup<ThemeSelectorFormGroup>;
  public fuseConfig: FuseConfig;

  private _changeDetectorRef = inject(ChangeDetectorRef);
  private _fuseConfigService = inject(FuseConfigService);
  private _localStorageService = inject(LocalStorageService);
  private _unsubscribeAll$: Subject<void> = new Subject();

  public ngOnDestroy(): void {
    // Unsubscribe from all subscriptions
    this._unsubscribeAll$.next();
    this._unsubscribeAll$.complete();
  }

  public ngOnInit(): void {
    // Build the config form
    // noinspection TypeScriptValidateTypes
    this.formGroup = new FormGroup<ThemeSelectorFormGroup>({
      colorTheme: new FormControl<string>(null!),
    });

    // Subscribe to the config changes
    this._fuseConfigService.config.pipe(takeUntil(this._unsubscribeAll$)).subscribe((config) => {
      // Update the stored config
      this.fuseConfig = config;

      // Set the config form values without emitting an event
      // so that we don't end up with an infinite loop
      this.formGroup.setValue(new ThemeSelector(config.colorTheme), { emitEvent: false });
      this._changeDetectorRef.markForCheck();
    });

    // Subscribe to the form value changes
    this.formGroup.valueChanges.pipe(takeUntil(this._unsubscribeAll$)).subscribe((config) => {
      // Update the config
      this._fuseConfigService.setConfig(config as Partial<FuseConfig>);
      this._localStorageService.write('THEME', JSON.stringify(config));
    });
  }
}
